// extracted by mini-css-extract-plugin
module.exports = {"root":"_89b3d6","quote":"_7e3533","author":"_16d055","icon":"_39166f"};